/**
 * featureFlags.js — central feature toggles.
 *
 * Flip a flag back to `true` and the entire UI for that feature comes back.
 * Keep this file tiny — only flags that gate UI surfaces across multiple files.
 */
export const FEATURES = {
    /**
     * Side-by-side college comparison.
     * Hidden Feb 2026 (founder request — partner colleges' egos in early stage).
     * Set to true to re-enable Compare across Navbar, CompareFAB, CollegeCard,
     * CollegeDetail, mobile menu, etc.
     */
    SHOW_COMPARE: false,

    /**
     * "Drop-Out Insurance" feature on the public Benefits page.
     * Hidden Feb 2026 (founder request — held back as a future offering).
     * When false, only admin users see the tab + section on /benefits.
     */
    SHOW_DROPOUT_INSURANCE_PUBLIC: false,
};
